export const MPC_ENTITIES = {
  NETWORK: 'networks',
  PODCASTER: 'podcasters',
  PODCAST: 'podcast',
  EPISODES: 'episodes',
  MARBYLS: 'marbyls',
  USERS: 'users',
};
